export default "__VITE_ASSET__I9$kG1iY__"